import {Component, OnInit} from '@angular/core';
import {VoilaUserService} from '@services/voila-user.service';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';
import {HeaderComponent} from '@app/header/header.component';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouteBuilder} from '@util/route-builder';
import {FreshdeskSupportComponent} from '@widgets/freshdesk-support/freshdesk-support.component';
import {LanguageService} from '@services/language.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [ToolbarComponent, HeaderComponent, MarkantElementsModule, RouterLink, RouterLinkActive, RouterOutlet, FreshdeskSupportComponent],
})
export class DashboardComponent implements OnInit {
  constructor(
    private readonly languageService: LanguageService,
    private readonly userService: VoilaUserService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.languageService.initBrowserLanguage();
  }

  get title(): string {
    const u = this.userService.currentUser();
    return `Willkommen, ${u.firstName}!`;
  }

  get routes() {
    return {
      welcome: RouteBuilder.app().startupDashboard().welcome().build(),
      profile: RouteBuilder.app().startupDashboard().profile().build(),
      product: RouteBuilder.app().startupDashboard().product().build(),
      preview: RouteBuilder.app().startupDashboard().preview().build(),
    };
  }

  /**
   *
   * @param buttonName
   * Checks which router URL is currently picked to highlight the currently "active" button.
   * Only works with the colorScheme attribute from Markant Elements.
   */
  pickedUrl(buttonName: string) {
    switch (buttonName.toLowerCase()) {
      case 'übersicht':
        if (this.router.url === this.routes.welcome) {
          return 'primary';
        }
        return 'secondary';

      case 'profil':
        if (this.router.url === this.routes.profile) {
          return 'primary';
        }
        return 'secondary';

      case 'produkt':
        if (this.router.url === this.routes.product) {
          return 'primary';
        }
        return 'secondary';

      case 'vorschau':
        if (this.router.url === this.routes.preview) {
          return 'primary';
        }
        return 'secondary';
    }
    return 'secondary';
  }
}
